type MoqMovSourceFieldsType = {
  order_requirement?: string
  moq_qty?: number
  moq_uom?: string
  moq_multiplier?: number
  moq_max?: boolean
  mov?: string
}

const CLEARED_MOQ_FIELDS = {
  moq_qty: 0,
  moq_uom: '',
  moq_multiplier: 1,
  moq_max: false,
} as const

export const sanitizeMoqMovFieldsByOrderRequirement = <T extends MoqMovSourceFieldsType>(
  info: T,
): T => {
  const orderRequirement = info.order_requirement ?? 'None'

  switch (orderRequirement) {
    case 'MoQ Only':
      return {
        ...info,
        mov: '0',
      }
    case 'MoV Only':
      return {
        ...info,
        ...CLEARED_MOQ_FIELDS,
      }
    case 'None':
    default:
      return {
        ...info,
        ...CLEARED_MOQ_FIELDS,
        mov: '0',
      }
  }
}
